
import { ElMessageBox } from 'element-plus'
import { h } from 'vue'
import { HouseUtils, TenderCheckedUtils, SiteBookingUtils } from './utils'
import { dateFormat } from '@/common/js/utils'
import HouseKeys from '@/common/tender/house/keys'

const alertFlag = {
  CONTROL_PRICE: false
}

const fn_royalty_parameters = (form, {config, isOnlySet, state}) => {
  if(isOnlySet) return false
  if(form.regionId !== 'x50002') return false // 厦航执行
  const { AlipayAccounts } = state.selections
  const value = form.royalty_parameters
  if (value) {
    AlipayAccounts.forEach(obj => {
      if (obj.Value === value) form.ROYALTY_REAL_NAME = obj.RealName
    })
  } else {
    form.ROYALTY_REAL_NAME = ''
  }

}

const fn_IS_REPORT = (form, {isOnlySet}) => {
  if (form.regionId.indexOf('x') === 0) return false
  if (form.IS_REPORT) {
    form.isReport = "是";
    form.isReportProvince = "是";
    form.IS_REPORT_PROVINCE = true;
    form.select_IS_REPORT_PROVINCE = "是";
  } else {
    form.isReport = "否";
    form.isReportProvince = "否";
    form.IS_REPORT_PROVINCE = false;
    form.select_IS_REPORT_PROVINCE = "否";

    form.REPORT_NUMBER = "";
    form.RECORD_NUMBER = "";

    form.PROJECT_NAME_disabled = false;
    form.REVIEW_STATUS = "";
    form.REVIEW_COMMENT = "";
  }
}

const fn_IS_SUBMIT_MARGIN = (form, {isOnlySet}) => {
  if(isOnlySet) return false
  if(form.IS_SUBMIT_MARGIN === '要求') {
    HouseUtils.initBondInfo(form)
    form.MARGIN_PAY_TYPE = [...new Set([...HouseUtils.getDefaultMargins(form), ...form.MARGIN_PAY_TYPE])]
  } else if (form.IS_SUBMIT_MARGIN === '不要求') {
    form.isBondOnline = false
    form.MARGIN_AMOUNT = "0.00"
    form.MARGIN_PAY_TYPE = []
    form.BOND_BANKS_SELECT = []
    form.BOND_BANKS = []
    form.OPENING_BANK = ""
    form.ACCOUNT_NAME = ""
    form.ACCOUNT_NUMBER = ""
    form.NON_REFUND = ""
  }
}

const fn_FORM_TO_SUBMIT_RENAME = (form, {isOnlySet}) => {
  if(isOnlySet) return false
  let value = form.FORM_TO_SUBMIT_RENAME
  if(value.indexOf('2') === -1) {
    form.HOW_TO_SUBMIT_RENAME_INLINE = '/'
  } else {
    form.HOW_TO_SUBMIT_RENAME_INLINE = ''
  }
  if(value.indexOf('1') === -1) {
    form.ADDRESS_TO_SUBMIT_RENAME_OUTLINE = '/'
    form.REQUIRE_TO_SECRET_RENAME_FILE = '/'
  } else {
    form.ADDRESS_TO_SUBMIT_RENAME_OUTLINE = ''
    form.REQUIRE_TO_SECRET_RENAME_FILE = ''
  }
}

const fn_BOND_BANKS_SELECT = (form, {state, isOnlySet, config}) => {
  HouseUtils.isInBzjAddress(form).then(() => {
    if(!isOnlySet) {
      if(['勘察', '建筑设计', '市政设计'].indexOf(form.type) >= 0) {
        form.MARGIN_BANK = ''
        form.MARGIN_NAME = ''
        form.MARGIN_NUMBER = ''
      } else {
        form.OPENING_BANK = ''
        form.ACCOUNT_NAME = ''
        form.ACCOUNT_NUMBER = ''        
      }
      form.BOND_BANKS = []
    }

    HouseUtils.resetBondBanks(form, {state, config, isOnlySet})
  }).catch(e => {
    HouseUtils.resetBondBanks(form, {state, config, isOnlySet})
  })
}

const fn_IS_REBID = (form, {config, isOnlySet}) => {
  if(isOnlySet) return false
  switch(form.type) {
    case '施工':
    case '园林绿化':
    case '工程总承包':
      config['/9/section-01'].REBID_TENDER_PROJECT_CODE.Disabled = form.IS_REBID === '0'
      break;
    case '监理':
      config['/7/section-01'].REBID_TENDER_PROJECT_CODE.Disabled = form.IS_REBID === '0'
      break;
    case '勘察':
    case '建筑设计':
    case '市政设计':
      config['/8/section-01'].REBID_TENDER_PROJECT_CODE.Disabled = form.IS_REBID === '0'
      break;
  }
  
  if(form.IS_REBID === '0') {
    form.REBID_TENDER_PROJECT_CODE = ''
  }
}

const fn_RemoteEval = (form, {isOnlySet}) => {
  if(isOnlySet) return false
  let pStyle = "margin: 5px 0; font-size: 15px; line-height: 26px;"
  if(form.RemoteEval !== '') {
    form.___RemoteEval___ = form.RemoteEval === '启用'
  }
  if (form.RemoteEval === '启用') {
    ElMessageBox({
      title: "启用须知",
      type: "waning",
      customStyle: "width: 560px",
      closeOnClickModal: false,
      message: h("div", {style: 'margin: 5px 10px'}, [
        h("p", { style: pStyle }, "1、如在非随行易交易自建或合作单位（交易中心、企业等）的场地进行评标，则无法对该评标室进行全景监控；"),
        h("p", { style: pStyle }, "2、请确保各个评标场所均具备可正常使用的语音麦克风与视频摄像头；"),
        h("p", { style: pStyle }, "3、专家总评报告需各场所专家自行签字并线下汇总。"),
      ]),
      showCancelButton: false,
      confirmButtonText: "已了解",
    }).then(() => {}).catch(e => null);
  }
}

const fn_SYNDICATED_FLAG = (form, {isOnlySet}) => {
  if(isOnlySet) return false
  if(form.SYNDICATED_FLAG === '接收') {
    if(form.ENTERPRISE_QUARTERLY_CREDIT2 === '/') form.ENTERPRISE_QUARTERLY_CREDIT2 = ''
    if(form.ENTERPRISE_QUARTERLY_CREDIT_ACCORDING === '/') form.ENTERPRISE_QUARTERLY_CREDIT_ACCORDING = ''
  }
}

const fn_CONTROL_PRICE = _.debounce((form, {isOnlySet}) => {
  if(isOnlySet) return false
  let value = form.CONTROL_PRICE
  TenderCheckedUtils.setPrice(value)
  if(!alertFlag.CONTROL_PRICE && /^[0-9]+\.[0-9]{2}$/.test(value)) {
    if(value < 1e4 || value > 1e10) {
      alertFlag.CONTROL_PRICE = true
      ElMessageBox.alert(h('p', null, [
        h('span', null, '当前输入金额为'),
        h('span', {style: 'color: red'}, `${value}元`),
        h('span', null, '，请确认金额是否正确，正确则忽略本条提示，不正确请自行修改为正确金额。')
      ]), '提示', {
        customClass: "ctba-message-info",
        type: 'info'
      }).then(() => {
        alertFlag.CONTROL_PRICE = false
      }).catch(e => {
        alertFlag.CONTROL_PRICE = false
      })
    }
  }
}, 1000)

const fn_IS_ABLE_ELE_GUARANTEE = (form, {isOnlySet}) => {
  if(isOnlySet) return false
  form.GUARANTEE_APPLICABLE_CONDITION = form.IS_ABLE_ELE_GUARANTEE === '采用' ? '' : '/'
}
// 是否需要总监答辩
const fn_IS_DIRECTOR_DEFENSE = (form, {isOnlySet}) => {
  if(isOnlySet) return false
  form.DIRECTOR_DEFENSE_SCORE = form.IS_DIRECTOR_DEFENSE === '是' ? '6' : '0'
}

const fn_IS_MULTIPLE_QUALIFICATIONS = (form, {isOnlySet}) => {
  if(isOnlySet) return false
  if(form.IS_MULTIPLE_QUALIFICATIONS === '是') form.SYNDICATED_FLAG = '接受'
}

const fn_TECHNICAL_DOCUMENTS_REQUIRE = (form, {isOnlySet}) => {
  if(isOnlySet) return false
  if(form.TECHNICAL_DOCUMENTS_REQUIRE === '要求') {
    form.TECHNICAL_DOCUMENTS = [{
      POST: "",
      POST_REMARK: "",
      POST_NUM: "",
      deletable: true,
      ORDER_NUMBER: 1
    }]
  } else {
    form.TECHNICAL_DOCUMENTS = []
  }
}

const fn_IS_OPEN = (form, {isOnlySet}) => {
  if(isOnlySet) return false
  form.IS_OPEN_INVITATION = form.IS_OPEN !== '不公开'
}

const fn_REGION_CODE = (form, {isOnlySet}) => {
  TenderCheckedUtils.setArea(form.REGION_CODE)
  HouseUtils.resetNoticeMedia(form)
  window.$sx.marginPayTypeOptions.resetOptions(form, HouseKeys)
}

const fn_SIMILAR_PROJECT_NUM1 = (form, {isOnlySet}) => {
  if (['0', '/'].indexOf(form.SIMILAR_PROJECT_NUM1) >= 0) {
    form.SIMILAR_PROJECT_CATEGORY1 = "/";
    form.SIMILAR_PROJECT_CATEGORY2 = "/";
    form.SIMILAR_PROJECT_LEVER1 = "/";
    form.ENTERPRISE_PERFORMANCE_SCORE = "0";
  } else {
    form.SIMILAR_PROJECT_CATEGORY1 = "";
    form.SIMILAR_PROJECT_CATEGORY2 = "";
    form.SIMILAR_PROJECT_LEVER1 = "";
    form.ENTERPRISE_PERFORMANCE_SCORE = "15";
  }
}

const fn_SIMILAR_PROJECT_NUM2 = (form, {isOnlySet}) => {
  if (['0', '/'].indexOf(form.SIMILAR_PROJECT_NUM2) >= 0) {
    form.SIMILAR_PROJECT_CATEGORY3 = "/";
    form.SIMILAR_PROJECT_CATEGORY4 = "/";
    form.SIMILAR_PROJECT_LEVER2 = "/";
    form.DIRECTOR_BASIC_QUALITY_SCORE = "0";
  } else {
    form.SIMILAR_PROJECT_CATEGORY3 = "";
    form.SIMILAR_PROJECT_CATEGORY4 = "";
    form.SIMILAR_PROJECT_LEVER2 = "";
    form.DIRECTOR_BASIC_QUALITY_SCORE = "15";
  }
}

const fn_OPEN_BID_SITE = _.debounce((form, {isOnlySet, obj}) => {
  if(isOnlySet) return false
  form.BID_OPEN_PLACE = ''
  // SiteBookingUtils.newValid(form, {isOnlySet, obj})
  fn_SITE_BOOKING_NUM(form, {isOnlySet, obj})
}, 500)

const fn_SITE_BOOKING_NUM = _.debounce((form, {isOnlySet, obj}) => {
  let value = form.SITE_BOOKING_NUM
  let reg_1 = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
  let reg_2 = /^[0-9a-f]{8}[0-9a-f]{4}[0-9a-f]{4}[0-9a-f]{4}[0-9a-f]{12}$/
  if(reg_1.test(value) || reg_2.test(value)) {
    SiteBookingUtils.newValid(form, {isOnlySet, obj})
  }
}, 500)

const fn_SUBMIT_TIME_DATE = _.debounce((form, {isOnlySet, args}) => {
  let value = form.SUBMIT_TIME_DATE
  if(value) {
    form.SUBMIT_TIME = dateFormat('yyyy-MM-dd HH:mm:ss', new Date(value.$date))
  } else {
    form.SUBMIT_TIME = ''
  }
}, 500)

const fn_SUP_OUTLINE_REQUIRE = _.debounce((form, {isOnlySet, args}) => {
  if(isOnlySet) return false
  form.SUPERVISION_OUTLINE_SCORE = form.SUP_OUTLINE_REQUIRE === '要求' ? '20' : '0'
})

const fn_RANDOM_MEHTODS_PROCEDURES = (form, {isOnlySet}) => {
  if(isOnlySet) return false
  form.CONCRETE_PROGRAM = ''
}

const fn_TENDER_PROJECT_CODE = (form, { isOnlySet, obj }) => {
  obj.Disabled = form.regionId.indexOf('x') === -1
}

const fn_IS_MUST_BIDDING_BY_LAW = (form) => {
  form.IS_MUST_BIDDING_BY_LAW = form.IS_MUST_BIDDING_BY_LAW_VALUE === '是'
}

const fn_IS_QUANTITIES_BILL = (form, { config }) => {
  config['/5/section-02'].CONTROL_PRICE_TABLE_DATA.Required = form.IS_QUANTITIES_BILL === '要求'
}

const fn_MARGIN_PAY_TYPE_SIGNOUT_NO = (form, { config }) => {
  let payTypeOptions = [
    'xxxx', '现金', '银行保函', '工程担保公司出具的担保保函', 
    '保险公司出具的投标保证保险', '年度投标保证金', '免缴投标保证金', '其他'
  ]
  switch(form.type) {
    case '园林绿化':
      payTypeOptions = [
        'xxxx', '现金', '银行保函', '工程担保公司出具的担保保函', '保险公司出具的投标保证保险', 
        '福建省建筑业龙头企业年度投标保证金', '年度投标保证金', 
      ]
      break;
    case '监理':
      payTypeOptions = [
        'xxxx', '现金', '银行保函', '年度投标保证金', 
        '工程担保公司出具的担保保函', '保险公司出具的投标保证保险'
      ]
      break;
    case '勘察':
    case '建筑设计':
    case '市政设计':
      payTypeOptions = [
        'xxxx', '现金', '年度投标保证金', '福建省建筑业龙头企业年度投标保证金形式', 
        '银行保函、担保保函或保证保险形式'
      ]
      break;
  }
  form.MARGIN_PAY_TYPE_SIGNOUT = (form.MARGIN_PAY_TYPE_SIGNOUT_NO || []).map(x => payTypeOptions[x])
}
const fn_EXPERT_NUM = (form, {config}) => {
  let {TENDERER_NUM, ECONOMY_EXPERT_NUM} = form
  let sum = 0
  if(/^\d+$/.test(TENDERER_NUM)) sum -= -TENDERER_NUM
  if(/^\d+$/.test(ECONOMY_EXPERT_NUM)) sum -= -ECONOMY_EXPERT_NUM
  form.EXPERT_NUM = sum
}
const fn_CONTROL_PRICE_TABLE_DATA = (form, {config}) => {
  if(form.CONTROL_PRICE_TABLE_DATA.length) form.CONTROL_PRICE_TABLE_DATA = [form.CONTROL_PRICE_TABLE_DATA.pop()]
}
const fn_DOC_PRICE = (form, {}) => {
  form.DOC_PRICE = (parseFloat(form.TENDER_FILE_PRICE) || 0) + (parseFloat(form.RELEVANT_INFORMATION) || 0)
  form.DOC_PRICE = form.DOC_PRICE.toFixed(2)
}

const fn_JS_EVAL_TYPE = (form, { obj }) => {
  if (form[obj.Key] === '合格制') {
    form.JY_SCORE = form.SS_SCORE = '0'
  }
}

export const houseHooks = (type, obj, args, form, config, state) => {
  let isOnlySet = args.pop()
  switch(type) {
    case "royalty_parameters":
      fn_royalty_parameters(form, {config, isOnlySet, state})
      break;
    case "BOND_BANKS_SELECT":
      fn_BOND_BANKS_SELECT(form, {config, isOnlySet, state})
      break;
    case "CONTROL_PRICE":
      fn_CONTROL_PRICE(form, { isOnlySet })
      break;
    case "CONTROL_PRICE_TABLE_DATA":
      fn_CONTROL_PRICE_TABLE_DATA(form, {config})
      break;
    case "DOC_PRICE":
      fn_DOC_PRICE(form, {  })
      break;
    case "EXPERT_NUM":
      fn_EXPERT_NUM(form, {config})
      break;
    case "FORM_TO_SUBMIT_RENAME":
      fn_FORM_TO_SUBMIT_RENAME(form, { isOnlySet })
      break;
    case "IS_ABLE_ELE_GUARANTEE":
      fn_IS_ABLE_ELE_GUARANTEE(form, { isOnlySet })
      break;
    case "IS_DIRECTOR_DEFENSE":
      fn_IS_DIRECTOR_DEFENSE(form, { isOnlySet })
      break;
    case "IS_MUST_BIDDING_BY_LAW":
      fn_IS_MUST_BIDDING_BY_LAW(form)
      break;
    case "IS_MULTIPLE_QUALIFICATIONS":
      fn_IS_MULTIPLE_QUALIFICATIONS(form, { isOnlySet })
      break;
    case "IS_OPEN":
      fn_IS_OPEN(form, { isOnlySet })
      break;
    case "IS_QUANTITIES_BILL":
      fn_IS_QUANTITIES_BILL(form, { config })
      break;
    case "IS_REBID":
      fn_IS_REBID(form, { config, isOnlySet })
      break;
    case "IS_REPORT":
      fn_IS_REPORT(form, {isOnlySet, state})
      break;
    case "IS_SUBMIT_MARGIN":
      fn_IS_SUBMIT_MARGIN(form, {isOnlySet, isOnlySet})
      break;
    case "JS_EVAL_TYPE":
      fn_JS_EVAL_TYPE(form, { obj })
      break;
    case "MARGIN_PAY_TYPE_SIGNOUT_NO":
      fn_MARGIN_PAY_TYPE_SIGNOUT_NO(form, { config })
      break;
    case "OPEN_BID_SITE":
      fn_OPEN_BID_SITE(form, { isOnlySet })
      break;
    case "RANDOM_MEHTODS_PROCEDURES":
      fn_RANDOM_MEHTODS_PROCEDURES(form, { isOnlySet })
      break;
    case "REGION_CODE":
      fn_REGION_CODE(form, { isOnlySet })
      break;
    case "RemoteEval":
      fn_RemoteEval(form, { isOnlySet })
      break;
    case "SIMILAR_PROJECT_NUM1":
      fn_SIMILAR_PROJECT_NUM1(form, {isOnlySet})
      break;
    case "SIMILAR_PROJECT_NUM2":
      fn_SIMILAR_PROJECT_NUM2(form, {isOnlySet})
      break;
    case "SITE_BOOKING_NUM":
      fn_SITE_BOOKING_NUM(form, { isOnlySet })
      break;
    case "SUBMIT_TIME_DATE":
      fn_SUBMIT_TIME_DATE(form, { isOnlySet, args })
      break;
    case "SUP_OUTLINE_REQUIRE":
      fn_SUP_OUTLINE_REQUIRE(form, {isOnlySet, isOnlySet})
      break;
    case "SYNDICATED_FLAG":
      fn_SYNDICATED_FLAG(form, { isOnlySet })
      break;
    case "TECHNICAL_DOCUMENTS_REQUIRE":
      fn_TECHNICAL_DOCUMENTS_REQUIRE(form, { isOnlySet })
      break;
    case "TENDER_PROJECT_CODE":
      fn_TENDER_PROJECT_CODE(form, { isOnlySet, obj })
      break;
    default: break;
  }
}